export default {
  submitInfo: '/v3/recruit/identity/info'
}
